import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import '../styles/components/bds-page.css';

const BDsPage = () => {
  const { user } = useAuth();
  const [bdList, setBdList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [period, setPeriod] = useState('month');

  useEffect(() => {
    fetchBDList();
  }, [period]);

  const fetchBDList = async () => {
    setLoading(true);
    try {
      const data = await api.getBDPerformance(period);
      setBdList(data.bd_statistics || []);
    } catch (error) {
      console.error('Failed to fetch BD list:', error);
    } finally {
      setLoading(false);
    }
  };

  const getPeriodLabel = () => {
    switch (period) {
      case '24h': return 'Last 24 Hours';
      case 'week': return 'Last Week';
      case 'month': return 'Last Month';
      case 'year': return 'Last Year';
      default: return '';
    }
  };

  if (loading) {
    return (
      <div className="bds-page">
        <div className="bds-header">
          <h1>Business Development Team</h1>
        </div>
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Loading BD team data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bds-page">
      <div className="bds-header">
        <h1>Business Development Team</h1>
        <p className="bds-subtitle">View and monitor all BD team members</p>
      </div>

      {/* Period Filter */}
      <div className="period-filter-section">
        <label>Performance Period:</label>
        <div className="period-buttons">
          <button
            className={`period-btn ${period === '24h' ? 'active' : ''}`}
            onClick={() => setPeriod('24h')}
          >
            24 Hours
          </button>
          <button
            className={`period-btn ${period === 'week' ? 'active' : ''}`}
            onClick={() => setPeriod('week')}
          >
            Week
          </button>
          <button
            className={`period-btn ${period === 'month' ? 'active' : ''}`}
            onClick={() => setPeriod('month')}
          >
            Month
          </button>
          <button
            className={`period-btn ${period === 'year' ? 'active' : ''}`}
            onClick={() => setPeriod('year')}
          >
            Year
          </button>
        </div>
      </div>

      {/* BDs List */}
      <div className="bds-list-section">
        <div className="section-header">
          <h2>BD Team Members - {getPeriodLabel()}</h2>
          <span className="bd-count-badge">{bdList.length} BDs</span>
        </div>

        {bdList.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">👥</div>
            <h3>No BDs Found</h3>
            <p>No Business Development representatives in the system</p>
          </div>
        ) : (
          <div className="bds-grid">
            {bdList.map((bd, index) => (
              <div key={bd.bd_name} className="bd-card">
                <div className="bd-card-header">
                  <div className="bd-avatar">
                    {bd.bd_name.charAt(0).toUpperCase()}
                  </div>
                  <div className="bd-info">
                    <h3>{bd.bd_name}</h3>
                    <span className="bd-rank">Rank #{index + 1}</span>
                  </div>
                </div>
                <div className="bd-card-body">
                  <div className="bd-stat">
                    <span className="stat-label">Jobs Created</span>
                    <span className="stat-value">{bd.job_count}</span>
                  </div>
                  {index === 0 && bd.job_count > 0 && (
                    <div className="top-performer-badge">
                      🏆 Top Performer
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BDsPage;
